<header #headerRef>
  @if (showPreHeader()) {
    <div class="pre-header">
      <p>{{'marketplace.header.photographer.content'|transloco}}</p>
      <button class="button button--small button--dark-grey button--text-white" [routerLink]="['/manage']">
        {{'marketplace.header.photographer.cta'|transloco}}
        <i class="fa-solid fa-arrow-right"></i>
      </button>
      <button class="close button button--close button--small button--transparent" (click)="closePreHeader()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  }
  <div class="header__content container">
    <app-logo
      [routerLink]="['/marketplace']"
    ></app-logo>

    <div class="right">
      <a class="button button--small button--primary" [routerLink]="['/gift-card']">
        <i class="fa-solid fa-gift"></i>
        {{'marketplace.header.offer-a-gift'|transloco}}
      </a>
      <div class="header__sub-menu header__sub-menu--customers">
        <button type="button" class="header__sub-menu-link button button--secondary button--transparent button--small"
                [routerLink]="['/']"
        >
          {{'marketplace.header.for-customers'|transloco}}
          <i class="fa-solid fa-chevron-down"></i>
        </button>
        <div class="header__sub-menu-content">
          <div #customersList class="header__sub-menu-content-list">
            <a class="header__sub-menu-content-link" href="/">
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-magnifying-glass"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <h3>{{'marketplace.header.submenu.customers.find.title'|transloco}}</h3>
                <p>{{'marketplace.header.submenu.customers.find.subtitle'|transloco}}</p>
              </div>
            </a>
            <a class="header__sub-menu-content-link" href="/?tags=wedding">
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-heart"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <h3>{{'marketplace.header.submenu.customers.wedding.title'|transloco}}</h3>
                <p>{{'marketplace.header.submenu.customers.wedding.subtitle'|transloco}}</p>
              </div>
            </a>
            <a class="header__sub-menu-content-link" href="/gift-card">
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-gift"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <div class="header__sub-menu-content-link__title">
                  <h3>{{'marketplace.header.submenu.customers.gift-card.title'|transloco}}</h3>
                  <span class="header__sub-menu-content-link__tag">
                    {{'marketplace.header.submenu.customers.gift-card.badge'|transloco}}
                  </span>
                </div>
                <p>{{'marketplace.header.submenu.customers.gift-card.subtitle'|transloco}}</p>
              </div>
            </a>
          </div>

          <div
            class="header__sub-menu-content-image"
            [style.height.px]="customersList?.offsetHeight"
          >
            <img src="assets/images/landing/for-customers.jpg" alt="{{'marketplace.header.submenu.customers.image-alt'|transloco}}"/>
          </div>
        </div>
      </div>
      <div class="header__sub-menu header__sub-menu--photographers">
        <button type="button" class="header__sub-menu-link button button--secondary button--transparent button--small"
                [routerLink]="['/manage']"
        >
          {{'marketplace.header.for-photographers'|transloco}}
          <i class="fa-solid fa-chevron-down"></i>
        </button>
        <div class="header__sub-menu-content">
          <div #photographersList class="header__sub-menu-content-list">
            <a class="header__sub-menu-content-link"
              [routerLink]="['/manage']"
              fragment="features"
            >
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-wand-magic-sparkles"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <h3>{{'marketplace.header.submenu.photographers.features.title'|transloco}}</h3>
                <p>{{'marketplace.header.submenu.photographers.features.subtitle'|transloco}}</p>
              </div>
            </a>
            <a class="header__sub-menu-content-link"
              [routerLink]="['/manage']"
              fragment="pricing"
            >
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-tags"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <h3>{{'marketplace.header.submenu.photographers.pricing.title'|transloco}}</h3>
                <p>{{'marketplace.header.submenu.photographers.pricing.subtitle'|transloco}}</p>
              </div>
            </a>
            <a class="header__sub-menu-content-link" href="/blog">
              <div class="header__sub-menu-content-link__icon">
                <i class="fa-solid fa-book-open-reader"></i>
              </div>
              <div class="header__sub-menu-content-link__content">
                <h3>{{'marketplace.header.submenu.photographers.resources.title'|transloco}}</h3>
                <p>{{'marketplace.header.submenu.photographers.resources.subtitle'|transloco}}</p>
              </div>
            </a>
          </div>

          <div
            class="header__sub-menu-content-image"
            [style.height.px]="photographersList?.offsetHeight"
          >
            <img src="assets/images/landing/for-photographers.jpg" alt="{{'marketplace.header.submenu.photographers.image-alt'|transloco}}"/>
          </div>
        </div>
      </div>
      <div class="button--user" #userButton>
        <button class="button button--circle button--light-grey" (click)="toggleUserMenu()">
          <app-user-image [user]="user" [size]="42"></app-user-image>
        </button>
        @if (userMenuOpened) {
          <app-header-user-menu
            #userMenu
            [user]="user"
            (onClose)="closeUserMenu()"
          ></app-header-user-menu>
        }
      </div>
    </div>

    <button
      class="button button--secondary button--transparent header__mobile-menu-button"
      type="button"
      (click)="toggleMobileMenu()"
      [attr.aria-label]="mobileMenuOpened ? ('marketplace.header.mobile-menu.close'|transloco) : ('marketplace.header.mobile-menu.toggle'|transloco)"
    >
      <i class="fa-solid" [ngClass]="mobileMenuOpened ? 'fa-xmark' : 'fa-bars'"></i>
    </button>
  </div>

  @if (mobileMenuOpened) {
    <div class="header__mobile-menu">
      @if (user) {
        <a class="header__mobile-menu__section header__mobile-menu__section--user"
           [routerLink]="[accountUrl()]"
        >
          <div class="header__mobile-menu__user">
            <app-user-image [user]="user" [size]="48"></app-user-image>
            <div>
              <p class="header__mobile-menu__user-label">{{'marketplace.header.account.label'|transloco}}</p>
              <p class="header__mobile-menu__user-name">{{ user.firstname || ('marketplace.header.user-menu.login'|transloco) }}</p>
            </div>
          </div>
        </a>
      } @else {
        <div class="header__mobile-menu__actions">
          <a class="button button--primary button--full-width" [routerLink]="['/login']">
            {{'marketplace.header.user-menu.login'|transloco}}
          </a>
          <a class="button button--white button--full-width" [routerLink]="['/register']">
            {{'marketplace.header.user-menu.register'|transloco}}
          </a>
        </div>
      }

      <div class="header__mobile-menu__section">
        <h3>{{'marketplace.header.for-customers'|transloco}}</h3>
        <div class="header__mobile-menu__links">
          <a class="header__sub-menu-content-link" href="/" (click)="closeMobileMenu()">
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <h3>{{'marketplace.header.submenu.customers.find.title'|transloco}}</h3>
              <p>{{'marketplace.header.submenu.customers.find.subtitle'|transloco}}</p>
            </div>
          </a>
          <a class="header__sub-menu-content-link" href="/?tags=wedding" (click)="closeMobileMenu()">
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-heart"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <h3>{{'marketplace.header.submenu.customers.wedding.title'|transloco}}</h3>
              <p>{{'marketplace.header.submenu.customers.wedding.subtitle'|transloco}}</p>
            </div>
          </a>
          <a class="header__sub-menu-content-link" href="/gift-card" (click)="closeMobileMenu()">
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-gift"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <div class="header__sub-menu-content-link__title">
                <h3>{{'marketplace.header.submenu.customers.gift-card.title'|transloco}}</h3>
                <span class="header__sub-menu-content-link__tag">
                  {{'marketplace.header.submenu.customers.gift-card.badge'|transloco}}
                </span>
              </div>
              <p>{{'marketplace.header.submenu.customers.gift-card.subtitle'|transloco}}</p>
            </div>
          </a>
        </div>
      </div>

      <div class="header__mobile-menu__section">
        <h3>{{'marketplace.header.for-photographers'|transloco}}</h3>
        <div class="header__mobile-menu__links">
          <a class="header__sub-menu-content-link"
             [routerLink]="['/manage']"
             fragment="features"
             (click)="closeMobileMenu()"
          >
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-wand-magic-sparkles"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <h3>{{'marketplace.header.submenu.photographers.features.title'|transloco}}</h3>
              <p>{{'marketplace.header.submenu.photographers.features.subtitle'|transloco}}</p>
            </div>
          </a>
          <a class="header__sub-menu-content-link"
             [routerLink]="['/manage']"
             fragment="pricing"
             (click)="closeMobileMenu()"
          >
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-tags"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <h3>{{'marketplace.header.submenu.photographers.pricing.title'|transloco}}</h3>
              <p>{{'marketplace.header.submenu.photographers.pricing.subtitle'|transloco}}</p>
            </div>
          </a>
          <a class="header__sub-menu-content-link" href="/blog" (click)="closeMobileMenu()">
            <div class="header__sub-menu-content-link__icon">
              <i class="fa-solid fa-book-open-reader"></i>
            </div>
            <div class="header__sub-menu-content-link__content">
              <h3>{{'marketplace.header.submenu.photographers.resources.title'|transloco}}</h3>
              <p>{{'marketplace.header.submenu.photographers.resources.subtitle'|transloco}}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  }
</header>
